import { render, staticRenderFns } from "./ProgressBarFreedom.vue?vue&type=template&id=5cb98ed8&scoped=true"
import script from "./ProgressBarFreedom.vue?vue&type=script&lang=js"
export * from "./ProgressBarFreedom.vue?vue&type=script&lang=js"
import style0 from "./ProgressBarFreedom.vue?vue&type=style&index=0&id=5cb98ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb98ed8",
  null
  
)

export default component.exports